/* tslint:disable */
/* eslint-disable */
/**
 * Podoactiva Backend Api Documentation
 * Podoactiva Backend Api Documentation
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface SendContestmailRequest {
    email?: string;
    fullName?: string;
    shinGuardPreview?: Blob;
    zipFile?: Blob;
}

/**
 * no description
 */
export class MailControllerApi extends runtime.BaseAPI {

    /**
     * Send participant email with fullname and email to podoactiva
     * sendContestmail
     */
    async sendContestmailRaw(requestParameters: SendContestmailRequest): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.email !== undefined) {
            formParams.append('email', requestParameters.email as any);
        }

        if (requestParameters.fullName !== undefined) {
            formParams.append('fullName', requestParameters.fullName as any);
        }

        if (requestParameters.shinGuardPreview !== undefined) {
            formParams.append('shinGuardPreview', requestParameters.shinGuardPreview as any);
        }

        if (requestParameters.zipFile !== undefined) {
            formParams.append('zipFile', requestParameters.zipFile as any);
        }

        const response = await this.request({
            path: `/send-contest-mail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Send participant email with fullname and email to podoactiva
     * sendContestmail
     */
    async sendContestmail(email?: string, fullName?: string, shinGuardPreview?: Blob, zipFile?: Blob): Promise<boolean> {
        const response = await this.sendContestmailRaw({ email: email, fullName: fullName, shinGuardPreview: shinGuardPreview, zipFile: zipFile });
        return await response.value();
    }

}
